/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI BMAW
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BudgetableUserReadModel
 */
export interface BudgetableUserReadModel {
    /**
     * 
     * @type {string}
     * @memberof BudgetableUserReadModel
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof BudgetableUserReadModel
     */
    firstActivity: Date;
    /**
     * 
     * @type {Date}
     * @memberof BudgetableUserReadModel
     */
    lastActivity: Date;
    /**
     * 
     * @type {number}
     * @memberof BudgetableUserReadModel
     */
    budgetLimit: number;
    /**
     * 
     * @type {number}
     * @memberof BudgetableUserReadModel
     */
    currentUsage: number;
    /**
     * 
     * @type {number}
     * @memberof BudgetableUserReadModel
     */
    approvedGuidelineVersion: number;
}

/**
 * Check if a given object implements the BudgetableUserReadModel interface.
 */
export function instanceOfBudgetableUserReadModel(value: object): value is BudgetableUserReadModel {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('firstActivity' in value) || value['firstActivity'] === undefined) return false;
    if (!('lastActivity' in value) || value['lastActivity'] === undefined) return false;
    if (!('budgetLimit' in value) || value['budgetLimit'] === undefined) return false;
    if (!('currentUsage' in value) || value['currentUsage'] === undefined) return false;
    if (!('approvedGuidelineVersion' in value) || value['approvedGuidelineVersion'] === undefined) return false;
    return true;
}

export function BudgetableUserReadModelFromJSON(json: any): BudgetableUserReadModel {
    return BudgetableUserReadModelFromJSONTyped(json, false);
}

export function BudgetableUserReadModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): BudgetableUserReadModel {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'firstActivity': (new Date(json['firstActivity'])),
        'lastActivity': (new Date(json['lastActivity'])),
        'budgetLimit': json['budgetLimit'],
        'currentUsage': json['currentUsage'],
        'approvedGuidelineVersion': json['approvedGuidelineVersion'],
    };
}

export function BudgetableUserReadModelToJSON(json: any): BudgetableUserReadModel {
    return BudgetableUserReadModelToJSONTyped(json, false);
}

export function BudgetableUserReadModelToJSONTyped(value?: BudgetableUserReadModel | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'firstActivity': ((value['firstActivity']).toISOString()),
        'lastActivity': ((value['lastActivity']).toISOString()),
        'budgetLimit': value['budgetLimit'],
        'currentUsage': value['currentUsage'],
        'approvedGuidelineVersion': value['approvedGuidelineVersion'],
    };
}

